<template>
  <v-snackbar
    v-model="showNotification"
    :timeout="-1"
    color="info"
    location="bottom right"
    variant="elevated"
  >
    Uma nova versão está disponível!
    <template v-slot:actions>
      <v-btn
        variant="text"
        @click="refreshApp"
      >
        Atualizar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const showNotification = ref(false)
const workerRegistration = ref(null)

const onUpdate = (event) => {
  showNotification.value = true
  workerRegistration.value = event.detail
}

// eslint-disable-next-line no-unused-vars
const refreshApp = () => {
  showNotification.value = false
  if (!workerRegistration.value || !workerRegistration.value.waiting) {
    return
  }
  // Envia a mensagem para o novo SW para que ele assuma o controle
  workerRegistration.value.waiting.postMessage({ type: 'SKIP_WAITING' })
}

// Adiciona os "ouvintes" de evento quando o componente é montado
onMounted(() => {
  document.addEventListener('swUpdated', onUpdate, { once: true })
  // Ouve o evento 'controllerchange', que é disparado quando um novo
  // service worker assume o controle. Recarrega a página SÓ ENTÃO.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload()
  })
})

// Limpa o "ouvinte" quando o componente é destruído
onUnmounted(() => {
  document.removeEventListener('swUpdated', onUpdate)
})
</script>
